const axios = require('axios');

const URL = 'https://staderverse.staderlabs.com';
const HEADERS = {'Content-Type': 'application/json'};

const getKyr = async () => {
    const config = {
        method: 'post',
        url: URL + '/kyrApiGetMetrics',
        headers: HEADERS,
        data: JSON.stringify({})
    };
    return (await axios(config).catch(function (error) {
        console.log(error);
    })).data;
}

/* eslint import/no-anonymous-default-export: [2, {"allowObject": true}] */
export default {getKyr};
